// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__a0ccR","fullScreen":"style_fullScreen__3+P+Q","header":"style_header__LGbrh","mobile":"style_mobile__lNXMX","zoom":"style_zoom__oXrYM"};